import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowReference } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type AlertSubscriptionViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  alertRuleValue: { displayId: string; id: string } | null;
  enabledValue?: { displayId: string; id: string } | null;
  enabled: boolean;
};

export const AlertSubscriptionViewForm: React.FC<AlertSubscriptionViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      alertRuleValue,
      enabled = false,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupAlertSubscriptionLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowReference
                  label={langStore.AlertSubscriptionAlertRuleLabel}
                  selectedValue={langStore.displayIdByLang(
                    alertRuleValue?.displayId
                  )}
                />
                <ShowBoolean
                  value={enabled}
                  label={langStore.AlertSubscriptionEnabledLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
